export const SpeedSelectorProps = {
  min: 1,
  max: 10,
  name: 'Speed',
};

export const DataSizeSelectorProps = {
  min: 5,
  max: 25,
  name: 'Size',
};
